import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";

const WishListSlice = createSlice({
  name: "wishList",
  initialState: {
    WishListData: [],
    WishListLoder: false,
  },
  reducers: {
    getWishListDataRequest: (state, action) => {
      return {
        ...state,
        WishListLoder: true,
      };
    },
    getWishListDataSuccess: (state, action) => {
      return {
        ...state,
        WishListData: action.payload,
        WishListLoder: false,
      };
    },
    getWishListDataFailure: (state, action) => {
      return {
        ...state,
        WishListLoder: false,
      };
    },
    userWishlistAddRequest(state, action) {
      return {
        ...state,
        WishListLoder: true,
      };
    },
    userWishlistAddSuccess(state, action) {
      // Swal.fire({
      //   position: "center",
      //   icon: "success",
      //   text: action?.payload?.message,
      // });
      return {
        ...state,
        WishListLoder: false,
      };
    },
    userWishlistAddFailure(state, action) {
      Swal.fire({
        position: "center",
        icon: "error",
        text: action?.payload?.message,
      });
      return {
        ...state,
        WishListLoder: false,
      };
    },
    userWishlistRemoveRequest: (state, action) => {
      return {
        ...state,
        WishListLoder: true,
      };
    },
    userWishlistRemoveSuccess: (state, action) => {
      return {
        ...state,
        WishListLoder: false,
      };
    },
    userWishlistRemoveFailure: (state, action) => {
      Swal.fire({
        position: "center",
        icon: "error",
        text: action?.payload?.message,
      });
      return {
        ...state,
        WishListLoder: false,
      };
    },
  },
});

export const {
  getWishListDataRequest,
  getWishListDataSuccess,
  getWishListDataFailure,
  userWishlistAddFailure,
  userWishlistAddRequest,
  userWishlistAddSuccess,
  userWishlistRemoveFailure,
  userWishlistRemoveRequest,
  userWishlistRemoveSuccess
} = WishListSlice.actions;
export default WishListSlice.reducer;
